import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

function RAMembersPortalButton({
    onRAMembersClick,
    buttonText,
    buttonColor
}) {
    return (
        <Fragment>
            <button
                className={`${buttonColor}-button`}
                onClick={onRAMembersClick}
            >{buttonText}
            </button>
        </Fragment>
    );
}

RAMembersPortalButton.propTypes = {
    onRAMembersPortalClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonColor: PropTypes.string.isRequired,
};

export default RAMembersPortalButton;
